<template>
  <div style="height: 100vh;background: #EBF7FF;">
    <div class="header-mobile container">
      <div
        style="flex-shrink: 0; width:20px; "
        class="mr-10"
        @click="handleBack"
      >
        <img :src="icons.ArrowLeftIcon" alt="" />
      </div>
      <h3 class="title">{{ $t("wap.text120") }}</h3>
      <div></div>
    </div>
    <div class="container">
      <div data-app class="navigate-container">
        <button @click="handleRedirect('booking')">
          <img :src="icons.CourseIcon" class="navigate-icon" />
          <p class="navigate-text">{{ $t("bookCourse") }}</p>
        </button>
        <!-- <button @click="handleRedirect('hio')">
          <img :src="icons.HioIcon" class="navigate-icon" />
          <p class="navigate-text">{{ $t("hio") }}</p>
        </button> -->
        <!-- <button @click="handleRedirect('handee')">
          <img :src="icons.HandeeIcon" class="navigate-icon" />
          <p class="navigate-text">{{ $t("handee") }}</p>
        </button>
        <button @click="handleRedirect('shop')">
          <img :src="icons.ShoppingIcon" class="navigate-icon" />
          <p class="navigate-text">{{ $t("shopping") }}</p>
        </button> -->
      </div>
    </div>
    <div class="empty" />
    <div class="text-center">
      <v-dialog v-model="showDialog" width="320">
        <v-card>
          <v-card-text
            style="font-weight: bold;
              height: 70px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 20px;
              padding-bottom: 0;"
            class="text-h5 grey lighten-2 text-center pt-10 fw-bold"
          >
            {{ $t("comingSoon") }}
          </v-card-text>

          <v-card-actions style="justify-content: center;">
            <v-btn @click="onClose" class="text-center button" color="#00aea9">
              <span class="c-white-text"> OK </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="img_bg">
      <img :src="imgs.BgGolf" alt="" />
    </div>
  </div>
</template>

<script>
import CourseIcon from "@/assets/img/svg/golf-booking-icon.svg";
import ShoppingIcon from "@/assets/img/svg/shop-icon.svg";
import HioIcon from "@/assets/img/navigate/hioV2.svg";
import HandeeIcon from "@/assets/img/navigate/handee.svg";
import BgGolf from "@/assets/img/BG_abstract_v2.png";
import ArrowLeftIcon from "@/assets/img/svg/arrow-left-icon.svg";
import { toggleChat } from "@/utils/helper";

export default {
  components: {},
  created() {},
  data() {
    return {
      infoHeader: {
        bg_color: "#EBF7FF",
        title: this.$t("wap.text120"),
        isShowHomeIcon: false
      },
      icons: {
        CourseIcon,
        ShoppingIcon,
        ArrowLeftIcon,

        HioIcon,
        HandeeIcon
      },
      imgs: {
        BgGolf
      },
      showDialog: false
    };
  },
  mounted() {
    toggleChat(false);
  },
  watch: {
    showDialog: function(newValue, old) {
      if (!newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    handleBack() {
      location.href = `/wap/bidv/redirect-app`;
    },
    handleRedirect(type) {
      let url = this.$router?.history?.current?.fullPath;
      let pathCurrent = "/navigate-bidv";
      switch (type) {
        case "hio":
          url = url.replace(pathCurrent, "/stb-hio");
          break;
        case "shop":
          url = url.replace(pathCurrent, "/stb-shop");
          break;
        case "handee":
          url = url.replace(pathCurrent, "/redirect-handde");
          break;
        default:
          url = url.replace(pathCurrent, "/wap");
          break;
      }
      window.location.href = url;
    },

    onClose() {
      this.showDialog = false;
    }
  },
  beforeDestroy() {
    toggleChat(true);
  }
};
</script>
<style scoped>
.img_bg {
  display: none;
}
.img_bg img {
  width: 100vw;
}
.navigate-container {
  display: flex;
  justify-content: center;

  /* align-items: center; */
  align-items: flex-start;
  width: 100vw;
}
.top-spacing {
  padding-top: 80px;
}

.navigate-text {
  font-family: Muli !important;
  margin-top: 10px;
  margin-bottom: 0;
  font-weight: 700;
  color: #0066ad;
  font-size: 1vw;
}

.navigate-icon {
  width: 5vw;
  height: 5vw;
}

.empty {
  width: 20vw;
}

.button {
  border-radius: 100px;
  width: 90px;
}
.header-mobile {
  height: 20px;
  padding: 30px 15px 40px 15px;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 35px !important;
  }
  .navigate-icon {
    width: 15vw;
    height: 15vw;
  }
  .navigate-text {
    margin-top: 1vw;
    margin-bottom: 0;
    font-weight: 700;
    color: #0066ad;
    font-size: 16px;
  }
  .img_bg {
    display: block;
    position: absolute;
    bottom: 0;
  }
  .title {
    font-weight: 700;
    color: black;
    font-size: 17px;
    padding-top: 2px;
  }
}
</style>
